module.exports = __webpack_public_path__ + "img/hills_roullet2.79c08f46.png";